import { useParams } from 'react-router-dom';
import ReportOnPlants from './ReportOnPlants';

const ReportOnPlantsWrapper = (props) => {
  const { sourceFromParams } = useParams();
  return <ReportOnPlants {...props} sourceFromParams={sourceFromParams} />;
};

export default ReportOnPlantsWrapper;
